module.exports = __webpack_public_path__ + "img/welcome.76f6b3c0.svg";